import PopupIcon from './PopupIcon';
import ImageAlignLeftIcon from './ImageAlignLeftIcon';
import ImageAlignCenterIcon from './ImageAlignCenterIcon';
import ImageAlignRightIcon from './ImageAlignRightIcon';
import MazlanIcon from './MazlanIcon.vue';

export const iconAliases = {
  'i-popup': PopupIcon,
  'i-image-align-left': ImageAlignLeftIcon,
  'i-image-align-center': ImageAlignCenterIcon,
  'i-image-align-right': ImageAlignRightIcon,
  'i-mazlan': MazlanIcon
};

export {
  PopupIcon,
  ImageAlignLeftIcon,
  ImageAlignCenterIcon,
  ImageAlignRightIcon,
  MazlanIcon
};
